import cn from 'classnames';
import { observer } from 'mobx-react-lite';
import React from 'react';

import s from './CheckCircle.module.scss';

interface ICheckCircle {
  id?: string;
  checked?: boolean;
  name?: string;
  title?: string;
  value?: string | string[];
  labelValue?: string;
  labelStyle?: string;
  CheckCircleStyle?: string;
  onChange?: (value?: string | string[]) => void;
}

const CheckCircle = ({
  id,
  checked = false,
  name,
  value,
  CheckCircleStyle,
  onChange,
  labelValue,
  labelStyle,
  title,
  ...props
}: ICheckCircle) => {
  return (
    <div
      className={s.CheckCircle__wrapper}
      onClick={(event) => {
        event.stopPropagation();
        event.preventDefault();
        onChange && onChange(value);
      }}
    >
      <input
        type="checkbox"
        id={id}
        className={cn(s.CheckCircle, { CheckCircleStyle })}
        value={value}
        name={name}
        checked={checked}
        onClick={(event) => {
          event.stopPropagation();
          event.preventDefault();
        }}
        onChange={() => {
          onChange && onChange(value);
        }}
        title={title}
        {...props}
      />
      <label htmlFor={id} className={labelStyle}>
        {labelValue}
      </label>
    </div>
  );
};

export default observer(CheckCircle);
